__turbopack_context__.v({
  "ra-accordion": "dPIL7a_ra-accordion",
  "ra-accordion--initial-run": "dPIL7a_ra-accordion--initial-run",
  "ra-accordion--mobile-nav": "dPIL7a_ra-accordion--mobile-nav",
  "ra-accordion--mobile-nav-subitem": "dPIL7a_ra-accordion--mobile-nav-subitem",
  "ra-accordion--open": "dPIL7a_ra-accordion--open",
  "ra-accordion--read-more": "dPIL7a_ra-accordion--read-more",
  "ra-accordion--rich-content": "dPIL7a_ra-accordion--rich-content",
  "ra-accordion__body": "dPIL7a_ra-accordion__body",
  "ra-accordion__header": "dPIL7a_ra-accordion__header",
  "ra-accordion__toggle": "dPIL7a_ra-accordion__toggle",
});
